
import Vue from "vue";
import AppMonthSelect from "@/components/common/MonthSelect.vue";
import { AuthService } from "@/services/auth-service";
import AppErrorMessageBox from "@/components/common/ErrorMessageBox.vue";
import AppQuarterInput from "@/components/common/QuarterInput.vue";
import { BookkeepingService, BookYearService } from "@/services";
import { IntraConsignmentData } from "@/services/bookkeeping-service";

export default Vue.extend({
	data(){
		return {
			quarter: 0,
			year: BookYearService.selectedBookYear,
			month: new Date().getMonth()+1,
			sending: false,
			createdData: null as null | IntraConsignmentData
		};
	},
	computed: {
		tabs():string[]{
			return [
				this.$ct("common.month").toString(),
				this.$ct("common.quarter-period").toString(),
			];
		},
		tabValue():number{
			if (this.quarter == 0){
				return 0;
			}
			return 1;
		},
		isQuarter():boolean {
			return this.quarter > 0;
		},
		yearInputWidth():string{
			if (this.isQuarter){
				return "12";
			}
			return "6";
		},
		isDossierFilledIn():boolean {
			let dossier = AuthService.wfDossier;
			return dossier.isFilledIn();
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async submit(){
			this.sending = true;
			try{
				this.createdData = await BookkeepingService.getIntraConsignmentData(this.year, this.month, this.quarter);
				if (!this.createdData.List || this.createdData.List.length == 0){
					let confirm = await this.$wf.confirm(this.$ct("intra-consignment-empty"), this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
					if (!confirm) {
						this.sending = false;
						this.close();
						return;
					}
				}
				await BookkeepingService.intraConsignmentDataToXml(this.createdData);
			}catch(err){

			}
			this.sending = false;
		},
		async downloadPdf(){
			if (!this.createdData) return;
			await BookkeepingService.intraConsignmentDataToPdf(this.createdData);
			this.close();
		},
		onTabInput(val:number){
			if (val == 0){
				this.quarter = 0;
			}else{
				this.quarter = 1;
			}
		}
	},
	components: {
		AppMonthSelect,
		AppErrorMessageBox,
		AppQuarterInput
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
